import React, { Component } from 'react';
import styled from "styled-components";
import backup from './error.jpg';


const StyledModal = styled.div`
  
  .modalInner {
  position:fixed;
  background: var(--yellow);
  transition: all 0.5s;
  width: 70%;
  height: auto;
  top:150%;
  left:50%;
  transform: translate(-50%,-50%);
  display: flex;
  }

  img{
    height: 300px;
  }

  .modalInfo{
    padding: 20px;
  }

  h3{
    border-bottom: 1px solid var(--black);
    padding-bottom: 15px;
    font-size: 20px;
    font-weight: 500;
  }

  p{
    border-bottom: 1px solid var(--black);
    padding: 10px 0;
  }

  a{
    border: 1px solid var(--black);
    padding: 6px;
  }

  a, button{
    background: none;
    height: auto;
    margin-right: 10px;
    margin-top: 10px;
  }

  a:hover, button:hover{
    color: var(--yellow);
    background: var(--black);
  }

  @media(max-width:668px){
    .modalInner{
      width: 85%;
      flex-direction: column;
    }

    img{
      width: 150px;
      height: auto;
      margin: 0 auto;
      margin-top: 20px;
    }
  }

  @media(max-width:400px){
    .modalInner{
      width: 95%;
    }

    img{
      width: 100px;
      height: auto;
      margin: 0 auto;
      margin-top: 20px;
    }

    .modalInfo{
      padding: 10px;
      font-size: 14px;
    }
  }


`



class Modal extends Component {

render(){
  
  if (this.props.movie === '') {
    return (
      <div className={"modal " + this.props.isModal}>
        <div className="modalInner" role="dialog" aria-modal="true">
          <p>Oops! Something went wrong!</p>
        </div>
      </div >
    )
  } else{
    return (
      <StyledModal className={"modal " + this.props.isModal} role="dialog" aria-modal='true'>
        <div className="modalInner">
          <img src={this.props.movie.Poster !== 'N/A' ? this.props.movie.Poster : backup} alt={'movie poster of' + this.props.movie.Title} name={this.props.movie.imdbID}/>
          <div className="modalInfo">
            <h3>{this.props.movie.Title} ({this.props.movie.Year})</h3>
            <p>Synopsis: {this.props.movie.Plot}</p>
            <p>Cast: {this.props.movie.Actors}</p>
            <p>Director: {this.props.movie.Director}</p>
            <p>IMDb Rating: {this.props.movie.imdbRating}</p>
            <a href={'https://www.imdb.com/title/' + this.props.movie.imdbID} target="_blank" rel="noreferrer">Go to IMDb page</a>
            <button onClick={this.props.goAway}>Close</button>
          </div>
        </div>
      </StyledModal>
    )
  }

}

}

export default Modal;